import { trackBirthdayCtaClickGA } from "@/lib/analytics";
import {
  storeCumpleCtaAttribution,
  type CumpleCtaSource,
} from "@/lib/birthdayCtaAttribution";
import { postCumpleSlackFunnel } from "@/lib/cumpleFunnel";
import { isInstagramBrowser } from "@/lib/instagramBrowserDetection";
import {
  getPostHogSlackSessionPropertiesPostHog,
  trackBirthdayCtaClickPostHog,
} from "@/lib/posthogAnalytics";
import { getWorkerGeoAnalyticsProps } from "@/lib/serverTemplateDetection";

export function trackBirthdayCtaClick(params: {
  source: CumpleCtaSource;
  href: string;
  label?: string;
  templateName?: string;
  elementId?: string;
  surface?: string;
  countryCode?: string;
  workerVariant?: string;
  extra?: Record<string, string | number | boolean | undefined>;
  /** Segundos en página antes del click (Slack engagement). */
  secondsToClick?: number;
  videoWatchedSeconds?: number;
  videoEnded?: boolean;
}): void {
  if (typeof window === "undefined") return;

  const phCtx = getPostHogSlackSessionPropertiesPostHog({ replayNearNow: true });
  const geo = getWorkerGeoAnalyticsProps();
  const province =
    (geo.user_province as string | undefined) ||
    (geo.province as string | undefined) ||
    undefined;

  storeCumpleCtaAttribution({
    source: params.source,
    source_template: params.templateName,
    source_path: window.location.pathname,
    source_url: window.location.href,
    href: params.href,
    label: params.label,
    element_id: params.elementId,
    surface: params.surface,
    country_code: params.countryCode || (geo.country as string | undefined),
    province,
    worker_variant: params.workerVariant,
    ph_session_id: phCtx.ph_session_id,
  });

  trackBirthdayCtaClickPostHog({
    source: params.source,
    href: params.href,
    label: params.label,
    templateName: params.templateName,
    elementId: params.elementId,
    surface: params.surface,
    countryCode: params.countryCode,
    workerVariant: params.workerVariant,
    extra: params.extra,
  });

  trackBirthdayCtaClickGA({
    source: params.source,
    templateName: params.templateName,
    label: params.label,
    href: params.href,
    elementId: params.elementId,
    extra: params.extra as Record<string, unknown> | undefined,
  });

  postCumpleSlackFunnel("cta_click_birthday", {
    sessionId: phCtx.ph_session_id,
    lastStep: "cta_click",
    timeOnPageSeconds: params.secondsToClick,
    extra: {
      cta_source: params.source,
      cta_href: params.href,
      cta_label: params.label ?? "",
      cta_element_id: params.elementId ?? "",
      cta_surface: params.surface ?? "",
      source_template: params.templateName ?? "",
      source_path: window.location.pathname,
      worker_variant: params.workerVariant ?? "",
      embedded_social_browser: isInstagramBrowser(),
      ...(params.secondsToClick != null
        ? { seconds_to_click: params.secondsToClick }
        : {}),
      ...(params.videoWatchedSeconds != null && params.videoWatchedSeconds > 0
        ? { video_watched_seconds: params.videoWatchedSeconds }
        : {}),
      ...(params.videoEnded ? { video_ended: true } : {}),
      ...params.extra,
    },
    replayNearNow: true,
  });
}